import { useMemo } from 'react';
import { useApolloClient } from '@apollo/client';
import { RiskIntelService } from '../RiskIntelService';
import { GraphqlRiskIntelService } from './GraphqlRiskIntelService';

export const useGraphqlRiskIntelService = (workspaceId?: string): RiskIntelService => {
  const client = useApolloClient();
  return useMemo(() => new GraphqlRiskIntelService(client, workspaceId), [client, workspaceId]);
};
